var _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-949 953 100 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-899 953.5c-26.2 0-47.5 21.3-47.5 47.5s21.3 47.5 47.5 47.5 47.5-21.3 47.5-47.5-21.3-47.5-47.5-47.5zm0 86.2c-21.3 0-38.7-17.4-38.7-38.7s17.4-38.7 38.7-38.7c21.3 0 38.7 17.4 38.7 38.7s-17.4 38.7-38.7 38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-876.4 1010.1c-1.9-1.5-4.6-1.3-6.2.6-.2.3-5.9 7-16.4 7s-16.2-6.7-16.4-7c-1.5-1.9-4.3-2.2-6.2-.7-1.9 1.5-2.2 4.3-.7 6.2.3.4 8.5 10.3 23.3 10.3s22.9-9.8 23.3-10.3c1.5-1.9 1.2-4.6-.7-6.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -914.7,
    cy: 990.2,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -883.3,
    cy: 990.2,
    r: 6.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyicon);
export default __webpack_public_path__ + "static/media/happyicon.4d733d2fa2855f6543e12a0feb5a00d7.svg";
export { ForwardRef as ReactComponent };